export default __webpack_public_path__ + "static/media/metamask-logo.6d9734d3.svg";